import { supabase } from '@/integrations/supabase/client';

export type AssessmentGrade = 'working_towards' | 'expected' | 'greater_depth';

export type WritingType =
  | 'story'
  | 'recount'
  | 'letter'
  | 'report'
  | 'instructions'
  | 'explanation'
  | 'persuasion'
  | 'poetry'
  | 'diary'
  | 'other';

// ---- Grade mapping --------------------------------------------------------

const GRADE_MAP: Record<string, AssessmentGrade> = {
  WTS: 'working_towards',
  ES:  'expected',
  GD:  'greater_depth',
};

export function mapGrade(raw: string | null | undefined): AssessmentGrade | null {
  if (!raw) return null;
  return GRADE_MAP[raw] ?? null;
}

// ---- Writing type labels --------------------------------------------------

export const WRITING_TYPE_LABELS: Record<WritingType, string> = {
  story:        'Story',
  recount:      'Recount',
  letter:       'Letter',
  report:       'Report',
  instructions: 'Instructions',
  explanation:  'Explanation',
  persuasion:   'Persuasion',
  poetry:       'Poetry',
  diary:        'Diary',
  other:        'Other',
};

export const FICTION_TYPES: WritingType[] = ['story', 'poetry', 'letter', 'diary'];

export const NONFICTION_TYPES: WritingType[] = [
  'recount', 'report', 'instructions', 'explanation', 'persuasion', 'other',
];

// ---- Accept / Override ----------------------------------------------------

export async function acceptAssessment(
  assessmentId: string,
  aiGrade: AssessmentGrade | null,
): Promise<import('@supabase/supabase-js').PostgrestError | null> {
  const { error } = await supabase
    .from('assessments')
    .update({ status: 'accepted', final_grade: aiGrade })
    .eq('id', assessmentId);
  return error ?? null;
}

export async function overrideAssessment(
  assessmentId: string,
  finalGrade: AssessmentGrade,
): Promise<import('@supabase/supabase-js').PostgrestError | null> {
  const { error } = await supabase
    .from('assessments')
    .update({ status: 'modified', final_grade: finalGrade })
    .eq('id', assessmentId);
  return error ?? null;
}
